import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Select
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import { selectedProformaInputsSelector } from 'store/selectors';
import { saveUW, setValuationTypeModalOptions, setTransientValuationType } from 'store/actions';

const ValuationTypeModal = ({
  classes,
  transientValuation,
  selectedOpportunity,
  selectedProformaInputs,
  setTransientValuationType,
  valuationTypeModalOptions,
  setValuationTypeModalOptions,
  saveUW,
  history
}) => {

  const handleValuationTypeDropdownChange = event => {
    const value = event.target.value
    setTransientValuationType(value)
  }

  const closeModal = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setValuationTypeModalOptions({ isOpen: false });
  }

  const onUpdateValuationTypeClicked = () => {

    const { nextTaskId, afterNavigation, callback } = valuationTypeModalOptions

    const saveUWPayload = {
      txnOppId: selectedOpportunity.id,
      proformaInputsContainerId: selectedProformaInputs.id,
      transientValuation,
      history,
      nextTaskId,
      afterNavigation,
      callback
    }

    saveUW(saveUWPayload)

    closeModal()
  }

  return (
    <Dialog open={valuationTypeModalOptions?.isOpen ?? false} onClose={closeModal} maxWidth='xs' fullWidth>
      <DialogTitle>
        Valuation Type
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={closeModal}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <div className={classes.dropdownSection}>
          <FormControl className={classes.valuationTypeBidDropdown}>
            <Select
                inputProps={{ name: 'valuationType', id: 'valuationTypeDropdown' }}
                value={transientValuation?.type ?? ''}
                onChange={handleValuationTypeDropdownChange}
              >
              {valuationTypeModalOptions?.possibleValues?.map(el => {
                return <MenuItem value={el} key={el}>{el}</MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button onClick={onUpdateValuationTypeClicked} variant="contained" color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = state => ({
  selectedOpportunity: state.propertyUWState.propertyUWClientTxnOpp,
  selectedProformaInputs: selectedProformaInputsSelector(state),
  updateValuationTypeDialogOpen: state.propertyUWState.updateValuationTypeDialogOpen,
  valuationTypeModalOptions: state.propertyUWState.valuationTypeModalOptions,
  transientValuation: state.propertyUWState.transientValuation,
});

const mapDispatchToProps = {
  saveUW,
  setValuationTypeModalOptions,
  setTransientValuationType
};

const styles = theme => ({
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
  dropdownSection: {
    gridArea: 'noBidDropdown',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  valuationTypeBidDropdown: {
    width: '100%',
  },
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ValuationTypeModal);